export default __webpack_public_path__ + "static/media/coveredCall.2fa5b74f.svg";